/**
 * Amino Z – Product page DOM tweaks + Mixed variant selector
 * - Move Offer block above media (desktop only)
 * - Put Qty selector + Add to Cart on one row
 * - Put Title + Price on one row (desktop)
 * - Mixed selector: Flavour dropdown + Size pills in ONE controller
 *
 * IMPORTANT:
 * This version removes ALL optional chaining (?.) to avoid:
 * "Uncaught SyntaxError: Unexpected token '.'"
 */

/* =====================================================
   Variant Mixed Selector (robust)
   - Extends theme <variant-dropdown> behaviour (base.js)
   - Collects option value IDs from BOTH dropdown + pills
   - Uses child product_url (combined listings) for fetch + URL
   - Robustly syncs carousel to new selection
   - Hides KG size row unless Serving Size = KG
   ===================================================== */
(function () {
  if (customElements.get("variant-mixed")) return;

  customElements.whenDefined("variant-dropdown").then(function () {
    if (customElements.get("variant-mixed")) return;

    var VariantDropdownCtor = customElements.get("variant-dropdown");

    class VariantMixed extends VariantDropdownCtor {
      connectedCallback() {
        if (typeof super.connectedCallback === "function") {
          super.connectedCallback();
        }
        this.syncServingSizeVisibility();
      }

      onVariantChange(e) {
        this.syncServingSizeVisibility();
        return super.onVariantChange(e);
      }

      /* ----------------------------
         URL helpers (combined listings)
         ---------------------------- */

      // Combined listings: prefer the selected value’s product_url if present
      getSelectedProductURL() {
        var selects = Array.prototype.slice.call(this.querySelectorAll("select"));
        for (var i = 0; i < selects.length; i++) {
          var sel = selects[i];
          var opt = sel && sel.selectedOptions ? sel.selectedOptions[0] : null;
          var url = opt && opt.dataset ? opt.dataset.productUrl : null;
          if (url) return url;
        }

        var checked = Array.prototype.slice.call(this.querySelectorAll('input[type="radio"]:checked'));
        for (var j = 0; j < checked.length; j++) {
          var radio = checked[j];
          var url2 = radio && radio.dataset ? radio.dataset.productUrl : null;
          if (url2) return url2;
        }

        return null;
      }

      // Collect BOTH dropdown + pills, ordered by option position
      updateOptions() {
        var optionBlocks = this.getOrderedOptionBlocks();
        var nextProductUrl = null;

        this.options = optionBlocks
          .map(function (block) {
            var select = block.querySelector("select");
            if (select) {
              var opt = select.selectedOptions && select.selectedOptions[0];
              if (opt && opt.dataset && opt.dataset.productUrl) nextProductUrl = opt.dataset.productUrl;
              return opt ? opt.dataset.optionValueId : null;
            }

            var checked = block.querySelector('input[type="radio"]:checked');
            if (checked && checked.dataset && checked.dataset.productUrl) nextProductUrl = checked.dataset.productUrl;
            return checked ? checked.dataset.optionValueId : null;
          })
          .filter(Boolean);

        this.__azSelectedProductUrl = nextProductUrl || null;
      }

      // Use child product URL when present (combined listings)
      get buildRequestURL() {
        var params = [];
        var productURL = this.__azSelectedProductUrl || this.getSelectedProductURL() || this.dataset.url;

        if (this.options && this.options.length) params.push("option_values=" + this.options.join(","));

        return productURL + "?section_id=" + this.sectionid + (params.length ? "&" + params.join("&") : "");
      }

      // Update browser URL to the child product when present
      updateURL() {
        if (!this.currentVariant) return;

        if (this.container && this.container.dataset && this.container.dataset.updateUrl === "false") return;

        var productURL = this.__azSelectedProductUrl || this.getSelectedProductURL() || this.dataset.url;
        window.history.replaceState({}, "", productURL + "?variant=" + this.currentVariant.id);
      }

      /* ----------------------------
         Regular Sizes / dependent option visibility
         ---------------------------- */

      getOrderedOptionBlocks() {
        var optionBlocks = Array.prototype.slice.call(this.querySelectorAll("[product-variant-option]"));

        optionBlocks.sort(function (a, b) {
          var ap = parseInt(a.getAttribute("data-option-position") || "0", 10);
          var bp = parseInt(b.getAttribute("data-option-position") || "0", 10);
          return ap - bp;
        });

        return optionBlocks;
      }

      getSelectedLabelFromBlock(block) {
        if (!block) return "";

        var select = block.querySelector("select");
        if (select) {
          var selectedOption = select.selectedOptions ? select.selectedOptions[0] : null;
          return selectedOption && selectedOption.dataset
            ? String(selectedOption.dataset.optionLabel || selectedOption.value || "").trim().toLowerCase()
            : "";
        }

        var checked = block.querySelector('input[type="radio"]:checked');
        return checked && checked.dataset
          ? String(checked.dataset.optionLabel || checked.value || "").trim().toLowerCase()
          : "";
      }

      blockHasRegularSizesValue(block) {
        if (!block) return false;

        var values = Array.prototype.slice.call(block.querySelectorAll('input[type="radio"], option'));
        for (var i = 0; i < values.length; i++) {
          var el = values[i];
          var label = String((el.dataset && el.dataset.optionLabel) || el.value || "").trim().toLowerCase();
          if (label === "regular sizes") return true;
        }

        return false;
      }

      getRegularSizesControllerBlock() {
        var optionBlocks = this.getOrderedOptionBlocks();

        for (var i = 0; i < optionBlocks.length; i++) {
          if (this.blockHasRegularSizesValue(optionBlocks[i])) return optionBlocks[i];
        }

        return null;
      }

      getDependentOptionBlocks(controllerBlock) {
        if (!controllerBlock) return [];

        var optionBlocks = this.getOrderedOptionBlocks();
        var controllerPosition = parseInt(controllerBlock.getAttribute("data-option-position") || "0", 10);

        return optionBlocks.filter(function (block) {
          var position = parseInt(block.getAttribute("data-option-position") || "0", 10);
          return position > controllerPosition;
        });
      }

      resetDependentBlockToServeFallback(block) {
        if (!block) return;

        var fallbackLabels = ["1 serve", "1serve", "single serve", "default", "n/a", "na", "hidden"];

        var select = block.querySelector("select");
        if (select) {
          var options = Array.prototype.slice.call(select.options);
          var fallback = options.find(function (opt) {
            var label = String((opt.dataset && opt.dataset.optionLabel) || opt.value || "").trim().toLowerCase();
            return fallbackLabels.indexOf(label) > -1;
          });

          if (fallback) select.value = fallback.value;
          return;
        }

        var radios = Array.prototype.slice.call(block.querySelectorAll('input[type="radio"]'));
        var radioFallback = radios.find(function (radio) {
          var label = String((radio.dataset && radio.dataset.optionLabel) || radio.value || "").trim().toLowerCase();
          return fallbackLabels.indexOf(label) > -1;
        });

        if (radioFallback) radioFallback.checked = true;
      }

      syncServingSizeVisibility() {
        var controllerBlock = this.getRegularSizesControllerBlock();

        // New one-option structure has no dependent row. Nothing to hide.
        if (!controllerBlock) return;

        var isRegularSizes = this.getSelectedLabelFromBlock(controllerBlock) === "regular sizes";
        var dependentBlocks = this.getDependentOptionBlocks(controllerBlock);

        dependentBlocks.forEach(function (block) {
          if (!isRegularSizes) this.resetDependentBlockToServeFallback(block);

          block.hidden = !isRegularSizes;
          block.style.display = isRegularSizes ? "" : "none";
        }, this);
      }

      /* ----------------------------
         Media syncing helpers
         ---------------------------- */

      // Find the "main" carousel in this product section (you have 2)
      getMainCarousel() {
        var container = this.container || this.closest(".main-product") || document;
        var carousels = Array.prototype.slice.call(container.querySelectorAll("product-carousel"));
        if (!carousels.length) return null;

        // Prefer one that contains a main-slider swiper container
        for (var i = 0; i < carousels.length; i++) {
          if (carousels[i].querySelector(".swiper-container[main-slider]")) return carousels[i];
        }

        // Otherwise prefer an active one
        for (var j = 0; j < carousels.length; j++) {
          if (carousels[j].classList && carousels[j].classList.contains("carousel-active")) return carousels[j];
        }

        return carousels[0];
      }

      // Try to slide Swiper to a given mediaId (data-media-id)
      slideToMediaId(mediaId) {
        var carousel = this.getMainCarousel();
        if (!carousel) return false;

        var swiperContainer =
          carousel.querySelector(".swiper-container[main-slider]") ||
          carousel.querySelector(".swiper-container.product-main-slide-container") ||
          carousel.querySelector(".swiper-container");

        var swiper = swiperContainer ? swiperContainer.swiper : null;
        if (!swiper) return false;

        var mediaEl = carousel.querySelector('[data-media-id="' + String(mediaId) + '"]');
        if (!mediaEl) return false;

        var slideEl = mediaEl.closest(".swiper-slide");
        if (!slideEl) return false;

        var slides = Array.prototype.slice.call(swiperContainer.querySelectorAll(".swiper-slide"));
        var index = slides.indexOf(slideEl);
        if (index < 0) return false;

        try {
          swiper.slideTo(index);
          return true;
        } catch (e) {
          return false;
        }
      }

      // Robustly sync media after a variant/product swap (retries until swiper exists)
      syncMediaAfterSwap() {
        var carousel = this.getMainCarousel();
        if (!carousel) return;

        // 0) Combined listings: prefer child product featured media id captured from fetched HTML
        var childId = this.__azChildFeaturedMediaId;
        if (childId) {
          var tries0 = 0;
          var maxTries0 = 30;
          var tick0 = () => {
            tries0 += 1;
            if (this.slideToMediaId(childId)) return;
            if (tries0 < maxTries0) window.requestAnimationFrame(tick0);
          };
          window.requestAnimationFrame(tick0);
          return;
        }

        // 1) Prefer variant featured_media if present
        var featuredId = null;
        if (this.currentVariant && this.currentVariant.featured_media && this.currentVariant.featured_media.id) {
          featuredId = this.currentVariant.featured_media.id;
        }

        // 2) Fallback to carousel attribute (theme uses this)
        var attrId = carousel.getAttribute("slide-to-media");

        // 3) Final fallback: first slide media id in DOM
        var firstDomMediaId = null;
        var firstMediaEl = carousel.querySelector("[data-media-id]");
        if (firstMediaEl) firstDomMediaId = firstMediaEl.getAttribute("data-media-id");

        var targetId = featuredId || attrId || firstDomMediaId;
        if (!targetId) return;

        var tries = 0;
        var maxTries = 20;
        var tick = () => {
          tries += 1;
          if (this.slideToMediaId(targetId)) return;
          if (tries < maxTries) window.requestAnimationFrame(tick);
        };

        window.requestAnimationFrame(tick);
      }

      /**
       * Override renderProductInfo:
       * - keeps theme fetch behaviour (section_id + option_values)
       * - swaps selectors/price/inventory
       * - re-applies your DOM tweaks
       * - then syncs the carousel after swap
       */
      renderProductInfo(cb) {
        var form = document.getElementById("product-form-" + this.dataset.section);
        var addButton = form ? form.querySelector('[name="add"]') : null;

        // Loading state (matches theme behaviour)
        try {
          if (addButton && window.HELPER_UTIL && window.HELPER_UTIL.submitButtonState) {
            window.HELPER_UTIL.submitButtonState(addButton).loadingState();
          }
        } catch (e) {}

        // Abort ongoing request
        if (this.AbortController) this.AbortController.abort();
        this.AbortController = new AbortController();

        var fetcher = window.HELPER_UTIL && window.HELPER_UTIL.fetchData ? window.HELPER_UTIL.fetchData : null;

        // If helper not available, fallback
        if (typeof fetcher !== "function") {
          return super.renderProductInfo(() => {
            this.syncServingSizeVisibility();
            if (window.AZReapplyProductPage) window.AZReapplyProductPage(this.container);
            this.syncMediaAfterSwap();
            if (cb) cb();
          });
        }

        return fetcher({
          method: "GET",
          config: { signal: this.AbortController.signal },
          url: this.buildRequestURL,
          responseType: "text",
          onsuccess: (data) => {
            var html = new DOMParser().parseFromString(data, "text/html");

            // Capture child product featured media id from fetched HTML (combined listings)
            var fetchedCarousel = html.querySelector("product-carousel");
            this.__azChildFeaturedMediaId = null;
            if (fetchedCarousel) {
              var firstMedia = fetchedCarousel.querySelector("[data-media-id]");
              if (firstMedia) this.__azChildFeaturedMediaId = firstMedia.getAttribute("data-media-id");
            }

            // Update currentVariant from returned JSON script
            var jsonEl = html.querySelector('[variant-block] [type="application/json"]');
            this.currentVariant = jsonEl ? JSON.parse(jsonEl.textContent) : null;

            // =====================================================
            // Combined listings image reliability fix:
            // If flavour selection points to a DIFFERENT child product URL,
            // do a hard navigation so the product-carousel/media is correct.
            // (Size changes on the same product will still stay AJAX.)
            // =====================================================
            var nextProductURL = this.__azSelectedProductUrl || this.getSelectedProductURL() || this.dataset.url;

            if (nextProductURL) nextProductURL = String(nextProductURL).split("?")[0];

            if (nextProductURL && window.location && window.location.pathname !== nextProductURL) {
              var target = nextProductURL;

              if (this.currentVariant && this.currentVariant.id) {
                target += "?variant=" + this.currentVariant.id;
              }

              window.location.href = target;
              return;
            }

            // 1) Swap variant block (selectors)
            var destVariantBlock = this.container.querySelector("[variant-block]");
            var srcVariantBlock = html.querySelector("[variant-block]");
            if (destVariantBlock && srcVariantBlock) {
              destVariantBlock.innerHTML = srcVariantBlock.innerHTML;
            }

            // Re-sync visibility after selector markup swap
            this.syncServingSizeVisibility();

            // 2) Swap price
            var destinationPrice = document.getElementById("price-" + this.dataset.section);
            var sourcePrice = html.getElementById(
              "price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
            );
            if (destinationPrice && sourcePrice) {
              destinationPrice.innerHTML = sourcePrice.innerHTML;
              destinationPrice.classList.remove("visibility-hidden");
            }

            // 3) Swap inventory (if present)
            var inventorySource = html.getElementById(
              "Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
            );
            var inventoryDestination = document.getElementById("Inventory-" + this.dataset.section);
            if (inventorySource && inventoryDestination) {
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            }

            // 4) Swap product-carousel (if section response includes it)
            var destCarousel = this.container.querySelector("product-carousel");
            var srcCarousel = html.querySelector("product-carousel");
            if (destCarousel && srcCarousel) {
              destCarousel.replaceWith(srcCarousel);
            }

            // 5) Toggle ATC based on availability
            try {
              if (typeof this.toggleAddButton === "function") {
                var isSoldOut = !this.currentVariant || this.currentVariant.available === false;
                var soldOutText =
                  window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : "Sold out";
                this.toggleAddButton(isSoldOut, soldOutText);
              }
            } catch (e) {}

            // 6) Re-run DOM placement tweaks after HTML swap
            if (window.AZReapplyProductPage) window.AZReapplyProductPage(this.container);

            // 7) Sync carousel after swap
            this.syncMediaAfterSwap();

            // 8) Keep the Afterpay app block in sync with the selected variant.
            if (window.AZUpdateAfterpayMessaging) {
              window.AZUpdateAfterpayMessaging(this.container, this.currentVariant);
            }

            if (cb) cb();
          },
          onerror: (error) => {
            if (error && error.name === "AbortError") return;
            console.log(error);
          },
          defaultCb: () => {
            try {
              if (addButton && window.HELPER_UTIL && window.HELPER_UTIL.submitButtonState) {
                window.HELPER_UTIL.submitButtonState(addButton).resetState(0);
              }
            } catch (e) {}
          },
        });
      }
    }

    customElements.define("variant-mixed", VariantMixed);
  });
})();

/* =====================================================
   Main product DOM enhancements
   ===================================================== */
(function () {
  var DESKTOP_MIN = 750;
  var PRODUCT_TYPE_SELECTOR = ".az-product-type";
  var AFTERPAY_PLACEMENT_SELECTOR = [
    "square-placement",
    "afterpay-placement",
    "[data-afterpay-placement]",
    "[data-placement-id][data-amount]"
  ].join(",");
  var AFTERPAY_BLOCK_SELECTOR = [
    ".az-afterpay-block",
    "[id*='afterpay_on_site_messaging']",
    "[id*='afterpay-on-site-messaging']",
    "[data-block-handle*='afterpay']"
  ].join(",");
  var RATING_SELECTOR = [
    ".jdgm-preview-badge",
    "[data-open-tabbed-group-tab='reviews']"
  ].join(",");

  function isDesktop() {
    return window.matchMedia("(min-width: " + DESKTOP_MIN + "px)").matches;
  }

  function getDirectChild(container, node) {
    if (!container || !node || !container.contains(node)) return null;

    var current = node;
    while (current && current.parentNode !== container) {
      current = current.parentNode;
    }

    return current && current.parentNode === container ? current : null;
  }

  function getExistingSummary(details) {
    if (!details) return null;

    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i].classList.contains("az-product-summary")) return details.children[i];
    }

    return null;
  }

  function getSummaryItem(details, selector, summaryClass) {
    var summary = getExistingSummary(details);
    if (summary) {
      var existing = summary.querySelector("." + summaryClass);
      if (existing) return existing;
    }

    var marker = details.querySelector(selector);
    if (!marker) return null;

    var existingItem = marker.closest("." + summaryClass);
    return existingItem || getDirectChild(details, marker);
  }

  function findAfterpayBlock(mainProduct, details) {
    var summary = getExistingSummary(details);
    if (summary) {
      var existing = summary.querySelector(".az-summary__afterpay");
      if (existing) return existing;
    }

    var blockMarker = mainProduct.querySelector(AFTERPAY_BLOCK_SELECTOR);
    if (blockMarker) {
      var block = blockMarker.closest(".shopify-app-block, .shopify-block, [id^='shopify-block-']") || blockMarker;
      return getDirectChild(details, block) || block;
    }

    var placement = mainProduct.querySelector(AFTERPAY_PLACEMENT_SELECTOR);
    if (!placement) return null;

    var placementBlock = placement.closest(".shopify-app-block, .shopify-block, [id^='shopify-block-']") || placement;
    return getDirectChild(details, placementBlock) || placementBlock;
  }

  function findRatingBlock(details, typeBlock, priceBlock) {
    var summary = getExistingSummary(details);
    if (summary) {
      var existing = summary.querySelector(".az-summary__rating");
      if (existing) return existing;
    }

    var marker = details.querySelector(RATING_SELECTOR);
    if (marker) {
      var appBlock = marker.closest(".shopify-app-block, .shopify-block, [id^='shopify-block-']") || marker;
      return getDirectChild(details, appBlock) || appBlock;
    }

    // Fallback for review app blocks positioned directly between
    // Product Type and Price in the theme block order.
    if (typeBlock && priceBlock && typeBlock.parentNode === details && priceBlock.parentNode === details) {
      var children = Array.prototype.slice.call(details.children);
      var typeIndex = children.indexOf(typeBlock);
      var priceIndex = children.indexOf(priceBlock);

      for (var i = typeIndex + 1; i < priceIndex; i++) {
        var candidate = children[i];
        if (
          candidate.matches(".shopify-app-block, .shopify-block, [id^='shopify-block-']") &&
          !candidate.matches(AFTERPAY_BLOCK_SELECTOR)
        ) {
          return candidate;
        }
      }
    }

    return null;
  }

  function insertChildrenInOrder(parent, children) {
    children.forEach(function (child, index) {
      if (!child) return;

      var currentAtIndex = parent.children[index] || null;
      if (currentAtIndex !== child) parent.insertBefore(child, currentAtIndex);
    });
  }

  function placeEnhancedSummary(mainProduct, state) {
    var details = mainProduct.querySelector(".main-product__details");
    if (!details) return false;

    var title = getSummaryItem(details, ".main-product__heading", "az-summary__title");
    var typeBlock = getSummaryItem(details, PRODUCT_TYPE_SELECTOR, "az-summary__type");
    var price = getSummaryItem(details, '[id^="price-"]', "az-summary__price");

    if (!title || !typeBlock || !price) return false;

    var afterpay = findAfterpayBlock(mainProduct, details);
    var rating = findRatingBlock(details, typeBlock, price);
    var summary = getExistingSummary(details);

    if (!summary) {
      summary = document.createElement("div");
      summary.className = "az-product-summary";
    }

    title.classList.add("az-summary__item", "az-summary__title");
    typeBlock.classList.add("az-summary__item", "az-summary__type");
    price.classList.add("az-summary__item", "az-summary__price");

    if (afterpay) {
      afterpay.classList.add("az-summary__item", "az-summary__afterpay", "az-afterpay-block");
    }

    if (rating) {
      rating.classList.add("az-summary__item", "az-summary__rating");
    }

    var hasVisibleAfterpay = Boolean(afterpay && !afterpay.classList.contains("az-afterpay-message-hidden"));
    summary.classList.toggle("az-product-summary--has-afterpay", hasVisibleAfterpay);
    summary.classList.toggle("az-product-summary--has-rating", Boolean(rating));

    insertChildrenInOrder(summary, [title, typeBlock, price, afterpay, rating].filter(Boolean));

    if (details.firstElementChild !== summary) details.insertBefore(summary, details.firstChild);

    var offer = mainProduct.querySelector(".offer");
    var mediaContainer = mainProduct.querySelector(".product-media-container");
    var descriptionMarker = mainProduct.querySelector(".main-product__description");
    var description = descriptionMarker ? getDirectChild(details, descriptionMarker) || descriptionMarker : null;

    if (isDesktop()) {
      if (offer && mediaContainer && (offer.parentNode !== mediaContainer || mediaContainer.firstElementChild !== offer)) {
        mediaContainer.insertBefore(offer, mediaContainer.firstChild);
      }

      if (description && summary.nextElementSibling !== description) {
        details.insertBefore(description, summary.nextSibling);
      }
    } else {
      if (offer && summary.nextElementSibling !== offer) {
        details.insertBefore(offer, summary.nextSibling);
      }

      if (description) {
        var descriptionAnchor = offer || summary;
        if (descriptionAnchor.nextElementSibling !== description) {
          details.insertBefore(description, descriptionAnchor.nextSibling);
        }
      }
    }

    state.enhancedSummary = true;
    return true;
  }

  function captureOriginalPosition(state, key, element) {
    if (!element || state[key] || !element.parentNode) return;

    var marker = document.createComment("AZ original block position");
    element.parentNode.insertBefore(marker, element);
    state[key] = { parent: element.parentNode, marker: marker };
  }

  function restoreOriginalPosition(original, element) {
    if (!original || !original.parent || !original.marker || !element) return;

    var expectedNext = original.marker.nextSibling;
    if (element.parentNode === original.parent && expectedNext === element) return;
    original.parent.insertBefore(element, expectedNext);
  }

  function placeStandardOffer(mainProduct, state) {
    var offer = mainProduct.querySelector(".offer");
    var mediaContainer = mainProduct.querySelector(".product-media-container");
    if (!offer || !mediaContainer) return;

    captureOriginalPosition(state, "offerOriginal", offer);

    if (isDesktop()) {
      if (offer.parentNode !== mediaContainer || mediaContainer.firstElementChild !== offer) {
        mediaContainer.insertBefore(offer, mediaContainer.firstChild);
      }
      offer.classList.add("az-offer--in-media");
    } else {
      restoreOriginalPosition(state.offerOriginal, offer);
      offer.classList.remove("az-offer--in-media");
    }
  }

  function placeStandardTitlePrice(mainProduct, state) {
    var details = mainProduct.querySelector(".main-product__details");
    if (!details) return;

    var title = details.querySelector(".main-product__heading");
    var price = details.querySelector('[id^="price-"]');
    if (!title || !price) return;

    if (!state.titlePlaceholder) {
      state.titlePlaceholder = document.createComment("AZ title position");
      title.parentNode.insertBefore(state.titlePlaceholder, title);
    }

    if (!state.pricePlaceholder) {
      state.pricePlaceholder = document.createComment("AZ price position");
      price.parentNode.insertBefore(state.pricePlaceholder, price);
    }

    var row = details.querySelector(".az-title-price-row");

    if (isDesktop()) {
      if (!row) {
        row = document.createElement("div");
        row.className = "az-title-price-row";
        details.insertBefore(row, state.titlePlaceholder);
      }

      insertChildrenInOrder(row, [title, price]);
    } else if (row) {
      state.titlePlaceholder.parentNode.insertBefore(title, state.titlePlaceholder.nextSibling);
      state.pricePlaceholder.parentNode.insertBefore(price, state.pricePlaceholder.nextSibling);
      row.remove();
    }
  }

  function placeQtyAtcRow(mainProduct) {
    var qtyWrap = mainProduct.querySelector(".product-quantity__selector-wrapper");
    var buttonsWrap = mainProduct.querySelector(".product-form__buttons");
    if (!qtyWrap || !buttonsWrap) return;

    var atcButton = buttonsWrap.querySelector('button[type="submit"][name="add"]');
    if (!atcButton) return;

    var existingRow = buttonsWrap.querySelector(".az-qty-atc-row");
    if (existingRow && !existingRow.contains(atcButton)) existingRow.remove();
    if (buttonsWrap.querySelector(".az-qty-atc-row")) return;

    var row = document.createElement("div");
    row.className = "az-qty-atc-row";
    row.appendChild(qtyWrap);
    row.appendChild(atcButton);
    buttonsWrap.insertBefore(row, buttonsWrap.firstChild);
  }

  function applyLayout(mainProduct) {
    if (!mainProduct) return;

    var state = mainProduct._azProductLayoutState || {};
    mainProduct._azProductLayoutState = state;

    var usedEnhancedSummary = placeEnhancedSummary(mainProduct, state);

    if (!usedEnhancedSummary) {
      placeStandardOffer(mainProduct, state);
      placeStandardTitlePrice(mainProduct, state);
    }

    placeQtyAtcRow(mainProduct);
  }

  function resolveMainProduct(target) {
    if (!target) return null;
    if (target.matches && target.matches(".main-product[product-info]")) return target;
    return target.closest ? target.closest(".main-product[product-info]") : null;
  }

  window.AZReapplyProductPage = function (target) {
    var requestedProduct = resolveMainProduct(target);

    if (requestedProduct) {
      applyLayout(requestedProduct);
      return;
    }

    Array.prototype.forEach.call(document.querySelectorAll(".main-product[product-info]"), applyLayout);
  };

  function init() {
    window.AZReapplyProductPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("resize", function () {
    window.AZReapplyProductPage();
  });

  document.addEventListener("shopify:section:load", function (event) {
    window.AZReapplyProductPage(event.target);
  });
})();

/* =====================================================
   Afterpay product messaging
   - Updates the app placement amount on every variant change
   - Hides the app block below the theme-wide minimum price
   ===================================================== */
(function () {
  var PLACEMENT_SELECTOR = [
    "square-placement",
    "afterpay-placement",
    "[data-afterpay-placement]",
    "[data-placement-id][data-amount]"
  ].join(",");

  var BLOCK_SELECTOR = [
    "[id*='afterpay_on_site_messaging']",
    "[id*='afterpay-on-site-messaging']",
    "[data-block-handle*='afterpay']"
  ].join(",");

  function parseCurrentVariant(productInfo) {
    var variantJson = productInfo.querySelector('[variant-block] script[type="application/json"]');
    if (!variantJson) return null;

    try {
      return JSON.parse(variantJson.textContent);
    } catch (error) {
      return null;
    }
  }

  function addUnique(list, seen, element) {
    if (!element || seen.indexOf(element) !== -1) return;
    seen.push(element);
    list.push(element);
  }

  function getAfterpayPlacements(productInfo) {
    return Array.prototype.slice.call(productInfo.querySelectorAll(PLACEMENT_SELECTOR));
  }

  function getAfterpayBlocks(productInfo, placements) {
    var blocks = [];
    var seen = [];

    Array.prototype.slice.call(productInfo.querySelectorAll(BLOCK_SELECTOR)).forEach(function (element) {
      var block = element.closest('.shopify-app-block, .shopify-block, [id^="shopify-block-"]') || element;
      addUnique(blocks, seen, block);
    });

    placements.forEach(function (placement) {
      var block = placement.closest('.shopify-app-block, .shopify-block, [id^="shopify-block-"]') || placement;
      addUnique(blocks, seen, block);
    });

    return blocks;
  }

  function updatePlacementAmount(placement, variant) {
    if (!placement || !variant || typeof variant.price !== "number") return;

    var amount = (variant.price / 100).toFixed(2);

    // Afterpay's On-Site Messaging API watches data-amount for changes.
    placement.setAttribute("data-amount", amount);
    if (placement.dataset) placement.dataset.amount = amount;

    if (variant.sku) {
      placement.setAttribute("data-item-skus", String(variant.sku));
      if (placement.dataset) placement.dataset.itemSkus = String(variant.sku);
    }
  }

  function updateAfterpayMessaging(productInfo, suppliedVariant) {
    if (!productInfo) return;

    var variant = suppliedVariant || parseCurrentVariant(productInfo);
    if (!variant || typeof variant.price !== "number") return;

    var placements = getAfterpayPlacements(productInfo);
    placements.forEach(function (placement) {
      updatePlacementAmount(placement, variant);
    });

    var minimumCents = Number(productInfo.getAttribute("data-afterpay-message-minimum-cents") || 0);
    var shouldHide = minimumCents > 0 && variant.price < minimumCents;
    var blocks = getAfterpayBlocks(productInfo, placements);

    blocks.forEach(function (block) {
      block.classList.add("az-afterpay-block");
      block.classList.toggle("az-afterpay-message-hidden", shouldHide);
      block.setAttribute("aria-hidden", shouldHide ? "true" : "false");
    });

    if (window.AZReapplyProductPage) {
      window.AZReapplyProductPage(productInfo);
    }
  }

  window.AZUpdateAfterpayMessaging = updateAfterpayMessaging;

  function queueUpdates(productInfo) {
    [0, 80, 250, 700, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        updateAfterpayMessaging(productInfo);
      }, delay);
    });
  }

  function initAfterpayMessaging(productInfo) {
    if (!productInfo || productInfo.getAttribute("data-afterpay-messaging-initialised") === "true") return;
    productInfo.setAttribute("data-afterpay-messaging-initialised", "true");

    queueUpdates(productInfo);

    productInfo.addEventListener("change", function (event) {
      var target = event.target;
      if (!target) return;

      var isVariantInput = target.matches('input[name="id"]');
      var isVariantControl = target.closest("variant-dropdown, variant-pills, variant-mixed");

      if (isVariantInput || isVariantControl) queueUpdates(productInfo);
    });

    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });

      if (shouldUpdate) queueUpdates(productInfo);
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function initAllAfterpayMessaging(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('.main-product[product-info]')).forEach(function (productInfo) {
      initAfterpayMessaging(productInfo);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllAfterpayMessaging(document);
    });
  } else {
    initAllAfterpayMessaging(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllAfterpayMessaging(event.target);
  });
})();